import React from 'react'
import { useSelector } from '@/store'
import Feedback from './FeedbackComponent'

const FeedbackComponent: React.FC = () => {
  // 是否开启rrweb
  const enable = useSelector((state) => state.configSlice.rrwebEnable === '1')
  const uid = useSelector((state) => state.user?.info?.uid)
  const countryCode = useSelector((state) => state.user?.info?.countryCode)
  const email = useSelector((state) => state.user?.info?.notificationEmail || state.user?.info?.email)
  const username = useSelector((state) => state.user?.info?.oneshipName)
  const lang = useSelector((state) => state.language.lang)
  const sellerId = useSelector((state) => state.user?.info?.sellerId)

  return <Feedback username={username} lang={lang} enable={enable} uid={uid} countryCode={countryCode} email={email} appId="ONE01" sellerId={sellerId} />
}

export default FeedbackComponent
